export const generateAnonymousId = (): string => {
  const hexDigits = '0123456789abcdef';
  let uuid = '';

  for (let i = 0; i < 36; i += 1) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      uuid += '-';
    } else if (i === 14) {
      uuid += '4';
    } else if (i === 19) {
      const randomIndex = Math.floor(Math.random() * 4);
      uuid += hexDigits[8 + randomIndex];
    } else {
      const randomIndex = Math.floor(Math.random() * 16);
      uuid += hexDigits[randomIndex];
    }
  }

  return uuid;
};

export const getOrCreateAnonymousId = (): string => {
  if (typeof window !== 'undefined') {
    let anonymousId = localStorage.getItem('anonymousId');
    if (!anonymousId) {
      anonymousId = generateAnonymousId();
      localStorage.setItem('anonymousId', anonymousId);
    }
    return anonymousId;
  }
  return '';
};
